export enum MetricType {
    YandexCounter = 1
}